import Model from './Model';

export default class extends Model {
  static data() {
    return {
      id: '',
      name: '',
      type_id: '',
      location: {
        lat: '',
        lng: '',
        name: '',
      },
      species_ids: [],
      project_ids: [],
    };
  }

  async findById(id) {
    let url = `/tours/${id}?` + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-tours'
      )
    );
  }

  async getTypes() {
    let url = '/tours/types';
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-tours-types'
      )
    );
  }

  async get() {
    let url = '/tours?' + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-tours'
      )
    );
  }

  async save(tour) {
    if (tour.id) {
      let url = `/tours/${tour.id}`;
      return this.patchPromise(url, tour);
    }
    return this.postPromise(`tours`, tour);
  }

  async delete(id) {
    let url = `/tours/${id}`;
    return this.deletePromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'delete-tour'
      )
    );
  }
}
